(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/capitalize', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/capitalize'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.capitalize, global.convert);
    global.capitalize = mod.exports;
  }
})(this, function (exports, _capitalize2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.capitalize = undefined;

  var _capitalize3 = _interopRequireDefault(_capitalize2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Converts the first character of string to upper case and the remaining to lower case.
   * @function
   * @memberof string
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @return {Object} Returns the updated object.
   * @example capitalize({ nested: { a: "a string" } }, 'nested.a') // => { nested: { a: "A string" } }
   * @see {@link https://lodash.com/docs#capitalize|lodash.capitalize} for more information.
   * @since 0.3.0
   */
  var capitalize = (0, _convert.convert)(_capitalize3.default);
  exports.capitalize = capitalize;
  exports.default = capitalize;
});